module.exports = __webpack_public_path__ + "media/images/video_clip-888045dbd6e1ef2d88daccf9fdd077f6.png";